import { useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchMe, type CurrentUser } from '@/lib/api'
import { clearToken, isAuthenticated } from '@/lib/auth'

// Resolves the current user from the stored token. Components use this to gate the
// editor and to show the live credit balance.
export function useAuth() {
  const queryClient = useQueryClient()

  const { data: user, isLoading } = useQuery<CurrentUser | null>({
    queryKey: ['me'],
    queryFn: fetchMe,
    enabled: isAuthenticated(),
    staleTime: 60_000,
  })

  function signOut() {
    clearToken()
    queryClient.setQueryData(['me'], null)
    queryClient.invalidateQueries({ queryKey: ['me'] })
  }

  return { user: user ?? null, isLoading, isAuthenticated: isAuthenticated(), signOut }
}
